<template>
    <div class="add-qwilr-block">
      <h3>Add Block</h3>
      <div class="form-group mb-4">
        <label for="name" class="form-label">Block</label>
        <select 
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedBlockId" @change="blockSelected"
            >
            <option disabled value="">Select a block</option>
            <option 
                v-for="(block, index) in qwilrBlocks" 
                :key="index" 
                :value="block.id"
            >
            {{ block.id }} - {{ block.name }}
            </option>
        </select>
      </div>
      <div class="form-group mb-4">
        <label for="qwilr-block-type" class="form-label">Block Type</label>
        <input
          type="text"
          id="qwilr-block-type"
          class="form-control"
          v-model="blockType"
          disabled
      />
      <p v-if="disableAdd" class="text-danger mt-2">
        The block can't be used due to technical limitation.
      </p>
      </div>
      <div class="form-group mb-4">
        <label for="qwilr-block-title" class="form-label">Title</label>
        <input
          type="text"
          id="qwilr-block-title"
          class="form-control"
          v-model="blockTitle"
          placeholder="Enter block title"
      />
      </div>
      <div class="form-group mb-4">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          placeholder="Enter block description"
          rows="4"
        ></textarea>
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="addBlock" :disabled="disableAdd||isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
              Add Block
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { GetBlocksFromQwilrApi, AddQwilrDefinitionElement } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { QwilrElementTypeId, DisabledElements } from "@/core/constant/QwilrElementId";

  export default{
    name:"AddQwilrDefinitionBlock",
    props:{
        qwilrDefinitionId:{
            type:String,
            required:true
        }
    },
    data(){
        return{
            qwilrBlocks:[],
            selectedBlockId:null,
            blockType:'',
            description:'',
            blockTitle:'',
            disableAdd:false,
            isBusy:false
        }
    },
    methods:{
        async fetchBlocksFromQwilrApi() {
            let data = await GetBlocksFromQwilrApi();
            if(data)
            {
            this.qwilrBlocks = data.qwilrBlocks;
            }

        },
        async blockSelected() {
            const selectedBlock = this.qwilrBlocks.find(
                (block) => block.id === this.selectedBlockId
            );
            this.description = selectedBlock ? selectedBlock.name : "";
            this.blockType = selectedBlock ? selectedBlock.type : "";
            this.blockTitle = selectedBlock ? selectedBlock.name : "";

            this.disableAdd=false
            if(DisabledElements.isDisabled(QwilrElementTypeId[this.blockType])){
              this.disableAdd=true
            }
        },
        async addBlock(){

            this.isBusy = true;
            setTimeout(async () => {
              if (!this.validateFields()) {
                this.isBusy=false;
                return;
              }

              const toast = useToast();
              const payload = { qwilrElementId:this.selectedBlockId,elementType:QwilrElementTypeId[this.blockType],description:this.description,qwilrDefinitionId:this.qwilrDefinitionId,title:this.blockTitle};
            
              await AddQwilrDefinitionElement(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Block added successfully!', {
                          timeout: 2000
                          })
                          this.isBusy=false
                          this.$emit('blockAdded'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy=false
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to add block : ${errorMessage}`, {timeout: 2000,});
                      })
              }, 500);
        },
        validateFields() {
          const toast = useToast();

          if (!this.selectedBlockId) {
            toast.error('Block is required!', { timeout: 3000 });
            return false; 
          }

          if (this.blockType.trim() === '') {
            toast.error('Block type is required!', { timeout: 3000 });
            return false; 
          }

          if (this.blockTitle.trim() === '') {
            toast.error('Block title is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    },
    created() {
        this.fetchBlocksFromQwilrApi();
    }
  }
 </script>
  
  <style scoped>
  .add-qwilr-block {
    width: 600px; /* Double the size */
    height: 600px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  